"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("../styles");
var core_1 = require("@material-ui/core");
var Utils_1 = require("../Utils");
var CircularProgressWithLabel = function (props) {
    var classes = (0, styles_1.useStyles)();
    var percentage = props.files.length * 100;
    var realPercentage = props.value + percentage;
    if (realPercentage > 0)
        realPercentage = realPercentage / props.files.length;
    return (react_1.default.createElement(core_1.Box, { position: "relative", display: "inline-flex" },
        react_1.default.createElement(core_1.CircularProgress, __assign({}, props, { value: realPercentage, variant: "determinate", size: 100, className: classes.circularProgressLabelCP })),
        react_1.default.createElement(core_1.Box, { top: 0, left: 0, bottom: 0, right: 0, position: "absolute", display: "flex", alignItems: "center", justifyContent: "center", onClick: function () { return (0, Utils_1.downloadMultipleFiles)(props.files); } }, props.value === 0 ? (react_1.default.createElement(core_1.Grid, { container: true, className: classes.circularProgressLabel1 },
            react_1.default.createElement("i", { className: "".concat(props.successIcon ? props.successIcon : "ppi ppi-check", " colorIcon") }))) : (react_1.default.createElement(core_1.Grid, { container: true, className: classes.circularProgressLabel2 },
            react_1.default.createElement("i", { className: "".concat(props.uploadIcon ? props.uploadIcon : "ppi ppi-cloud-upload", " colorIcon") }))))));
};
exports.default = CircularProgressWithLabel;
